import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import WhatWeProvidePage from "./pages/WhatWeProvidePage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import JoinCommunityPage from "./pages/JoinCommunityPage";
import ThankYouPage from "./pages/ThankYouPage";
import CourseLoginPage from "./pages/CourseLoginPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/what-we-provide" element={<WhatWeProvidePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/join" element={<JoinCommunityPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/course-login" element={<CourseLoginPage />} />
          <Route path="/members" element={<CourseLoginPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#0B1220",
            border: "1px solid rgba(16, 185, 129, 0.3)",
            color: "#F8FAFC",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
